import { render, staticRenderFns } from "./SyncSummaryData.vue?vue&type=template&id=1873201c&scoped=true&lang=pug"
import script from "./SyncSummaryData.vue?vue&type=script&lang=js"
export * from "./SyncSummaryData.vue?vue&type=script&lang=js"
import style0 from "./SyncSummaryData.vue?vue&type=style&index=0&id=1873201c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1873201c",
  null
  
)

export default component.exports